/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Alert } from 'reactstrap';
import { get, has } from 'lodash';

import { Button, FormHeader, FormButtonsWrapper, FormItem, Spinner } from '@skunexus/component-catalog';
import { useMSIFields, FIELD_PATH } from './useMSIFields';

import styles from './styles.module.css';

function MSIFields(props) {
    const { details, dictionaries, isLoading, formData } = props;
    const { msiMapError, handleAddPair, handleRemovePair, handleChangeField } = useMSIFields(props);

    if (!has(details, 'id'))
        return <Alert color="warning">Options for mapping will be displayed when editing the integration.</Alert>;

    if (isLoading)
        return (
            <div className="py-4">
                <Spinner />
            </div>
        );

    return (
        <div>
            <Row>
                <Col>
                    <FormHeader>MSI</FormHeader>
                </Col>
            </Row>
            {get(formData, FIELD_PATH, []).map(({ warehouse_id = '', source_code = '' }, key) => (
                <Row className="mb-4">
                    <Col sm={6}>
                        <FormItem
                            label="Warehouse"
                            name={`${FIELD_PATH}[${key}].warehouse_id`}
                            type="dropdown"
                            value={warehouse_id}
                            options={get(dictionaries, 'warehouses', [])}
                            validate={{ required: { value: true } }}
                            onChange={(value) => handleChangeField(key, 'warehouse_id', value)}
                        />
                    </Col>
                    <Col sm={6}>
                        <div className={styles.sourceValueCol}>
                            <FormItem
                                label="Source"
                                name={`${FIELD_PATH}[${key}].source_code`}
                                type="dropdown"
                                value={source_code}
                                options={get(dictionaries, 'msiSources', [])}
                                validate={{ required: { value: true } }}
                                onChange={(value) => handleChangeField(key, 'source_code', value)}
                            />
                            <Button outline onlyIcon size="sm" icon="Trash3" onClick={() => handleRemovePair(key)} />
                        </div>
                    </Col>
                </Row>
            ))}
            {msiMapError && (
                <Row>
                    <Col className="mt-3">
                        <Alert color="danger">Each warehouse can only be paired with one source.</Alert>
                    </Col>
                </Row>
            )}
            <Row>
                <Col sm={5}>
                    <FormButtonsWrapper className="mt-0 mb-4">
                        <Button outline size="sm" icon="PlusCircle" onClick={handleAddPair}>
                            Add Another MSI
                        </Button>
                    </FormButtonsWrapper>
                </Col>
            </Row>
        </div>
    );
}

MSIFields.propTypes = {
    details: PropTypes.object,
    formData: PropTypes.object,
    dictionaries: PropTypes.object,
    isLoading: PropTypes.bool,
};
MSIFields.defaultProps = {
    details: {},
    formData: {},
    dictionaries: {},
    isLoading: false,
};

export default MSIFields;
